import React, {useState} from "react";
import {isEmpty} from "lodash";
import {Row, Col, FormGroup, Input, ModalFooter} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import Toggle from "react-toggle";
import {_Buttons} from "../../constants/appConstants";
import ZeusButton from "../../components/Button";
import {sendContactModalData} from "../../redux/Actions/contacts.actions";
import {getOrganization} from "../../redux/Selectors/root.selector";
import {useFetchContacts} from "../../views/Contacts/contactsTable/useContactTableData";

const DEFAULT_DATA = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  is_primary: false,
};

const AddContactForm = (props) => {
  const {data, onCancel} = props;
  const dispatch = useDispatch();
  const {refetch} = useFetchContacts();
  const [submitted, setSubmitted] = useState(false);
  const org = useSelector(getOrganization);
  const [formData, setFormData] = useState(data || DEFAULT_DATA);
  const {first_name = "", last_name = "", email = "", phone = "", is_primary} = formData;

  const onFormSubmit = () => {
    setSubmitted(true);
    const callback = () => {
      onCancel();
      refetch();
    };
    if (!isEmpty(first_name) && !isEmpty(email)) {
      const payload = {...formData, organization: org.id};
      dispatch(sendContactModalData(payload, callback));
    } else {
      toast.error("Please check required fields");
    }
  };

  const onChangeHandler = (e) => {
    const {type, value, checked} = e.target;

    let updateObj = {...formData};
    updateObj = Object.assign({}, updateObj, {
      [e.target.name]: type === "checkbox" ? checked : value,
    });
    setFormData(updateObj);
  };

  return (
    <>
      <div>
        <div className="pl-lg-4">
          <Row>
            <Col lg="12">
              <FormGroup>
                <label className="form-control-label" htmlFor="first_name">
                  First Name
                  <span className="text-red">*</span>
                </label>
                <Input
                  className="form-control-alternative"
                  placeholder="Enter First Name"
                  type="text"
                  name="first_name"
                  value={first_name}
                  invalid={isEmpty(first_name) && submitted}
                  data-cy="first_name"
                  onChange={onChangeHandler}
                />
              </FormGroup>
            </Col>
            <Col lg="12">
              <FormGroup>
                <label className="form-control-label" htmlFor="first_name">
                  Last Name
                  <span className="text-red">*</span>
                </label>
                <Input
                  className="form-control-alternative"
                  placeholder="Enter Last Name"
                  type="text"
                  name="last_name"
                  value={last_name}
                  invalid={isEmpty(last_name) && submitted}
                  data-cy="last_name"
                  onChange={onChangeHandler}
                />
              </FormGroup>
            </Col>
            <Col lg="12">
              <FormGroup>
                <label className="form-control-label" htmlFor="first_name">
                  Email
                  <span className="text-red">*</span>
                </label>
                <Input
                  className="form-control-alternative"
                  placeholder="Enter Email"
                  type="email"
                  name="email"
                  value={email}
                  invalid={isEmpty(email) && submitted}
                  data-cy="email"
                  onChange={onChangeHandler}
                />
              </FormGroup>
            </Col>
            <Col lg="12">
              <FormGroup>
                <label className="form-control-label" htmlFor="first_name">
                  Phone Number
                  <span className="text-red">*</span>
                </label>
                <Input
                  className="form-control-alternative"
                  placeholder="Enter Phone Number"
                  type="text"
                  name="phone"
                  value={phone}
                  invalid={isEmpty(phone) && submitted}
                  data-cy="phone"
                  onChange={onChangeHandler}
                />
              </FormGroup>
            </Col>
            <Col lg="12">
              <FormGroup>
                <label className="form-control-label" htmlFor="check-code">
                  Primary Contact ?
                </label>
                <Toggle
                  checked={is_primary}
                  name={"is_primary"}
                  onChange={onChangeHandler}
                />
              </FormGroup>
            </Col>
          </Row>
        </div>
      </div>
      <ModalFooter>
        <ZeusButton onClick={() => onFormSubmit()} data-cy="submit-btn">
          {_Buttons.SAVE}
        </ZeusButton>
        <ZeusButton onClick={onCancel} data-cy="cancel-btn" className="info-small">
          {_Buttons.CANCEL}
        </ZeusButton>
      </ModalFooter>
    </>
  );
};

export default AddContactForm;
